import React from "react";
import PropTypes from "prop-types";
import { Link } from "redux-little-router";
import CaseActionsDropdownContainer from "../../../PostsList/components/CaseActionsDropdownContainer";
import ProfilePicture from "../../../ProfilePicture";
import { constructUserProfilePath } from "../../../../util/index";
import FollowToggleButton from "../../../FollowToggleButton";
import "./index.css";

function PostHeader({ className = "-card-header", post, closeModal, container }) {
  const { owner } = post;
  const profilePath = constructUserProfilePath(owner);

  return (
    <header className={className}>
      <Link href={profilePath} onClick={closeModal}>
        <ProfilePicture userId={owner.id} size="s" fallbackUrl={owner.picture} alt="Avatar" className="-user-img" />
      </Link>
      <div className="-card-data">
        <Link href={profilePath} className="-user-name" onClick={closeModal}>
          {owner.name}
        </Link>
        {owner.speciality && owner.speciality !== "Other" && <p className="-user-speciality">{owner.speciality}</p>}
      </div>
      <div className="owner-follow">
        {container === "postpage" && (
          <FollowToggleButton userId={owner.id} postId={post._id} isFollowed={owner.isFollowed} />
        )}
      </div>
      <CaseActionsDropdownContainer post={post} />
    </header>
  );
}

PostHeader.propTypes = {
  closeModal: PropTypes.func,
};

export default PostHeader;



// WEBPACK FOOTER //
// ./src/components/Post/Components/PostHeader/index.js